import { trpc } from "@utils/trpc";
import { getQueryKey } from "@trpc/react-query";

/**
 * Paginated DJ Sets browse (albums whose song carries a setlist, release date
 * desc) — the content feed behind the "DJ Sets" category tile. Mirrors
 * useContentByGenre's pagination shape; no durable cache for v1 (the page is
 * cheap to refetch and the mixed decompose machinery isn't needed for an
 * albums-only feed).
 */
export const useSetlists = (options?: any) => {
  const input = { limit: 12 };
  const queryKey = getQueryKey(
    trpc.catalog.setlists.listPaginated,
    input,
    "infinite",
  );
  const query = trpc.catalog.setlists.listPaginated.useInfiniteQuery(input, {
    ...options,
    enabled: options?.enabled !== undefined ? options?.enabled : true,
    getNextPageParam: (lastPage: { endCursor?: number }) => {
      return lastPage.endCursor;
    },
    getPreviousPageParam: (firstPage: { startCursor?: number }) => {
      return firstPage.startCursor;
    },
    initialCursor: undefined,
    staleTime: 60 * 60 * 1000, // 1 hour — parity with genre browse
  });

  return { query, queryKey };
};
